__turbopack_context__.v({
  "IframeWrapper": "iframe-wrapper-module-scss-module__Ak_vMa__IframeWrapper",
});
